<template>
  <LazyHomeCommonLayout :is-blog-banner="true">
    <template #content>
      <section id="event" class="event subPageSection">
        <div class="backBg"></div>
        <div class="containerMain">
          <div class="detailPage eventDetail">
            <NuxtLink :to="{name: RouteName.HomeEvents}" class="backBtn flex"><span></span><p>{{ t("home-event-all") }}</p></NuxtLink>
            <template v-if="isInit">
              <section class="detailBanner" :class="{closed: event.eventData.isEventEnded}">
                <div class="imgArea">
                  <div v-if="event.eventData.isEventEnded" class="label closed">{{ t("common-closed") }}</div>
                  <NuxtImg :src="event.imageUrl" alt="thumbnail image" format="webp" />
                </div>
              </section>
              <section class="detailWrap flex">
                <div class="leftArea">
                  <div class="editorArea">
                    <div class="titleArea">
                      <ul class="labelArea flex">
                        <!-- 색상에 따라 blue, green, purple, red 라벨 주세요 default dark 라벨 -->
                        <li v-if="event.eventData.engage" class="label" :class="event.eventData.engageColor">
                          {{ t(`home-event-engage-${event.eventData.engage}`) }}
                        </li>
                        <li v-if="event.eventData.type" class="label" :class="event.eventData.typeColor">
                          {{ t(`home-event-type-${event.eventData.type}`) }}
                        </li>
                      </ul>
                      <h2>{{ event.title }}</h2>
                      <div class="info">{{ event.info }}</div>
                      <!-- sideInfo 1024px 부터 노출 -->
                      <div class="sideInfo flex">
                        <div class="title">{{ t("home-event-info") }}</div>
                        <ul>
                          <li>
                            <div class="tit">{{ t("home-event-info-date") }}</div>
                            <div class="info">{{ eventDateText }}</div>
                          </li>
                          <li>
                            <div class="tit">{{ t("home-event-info-period") }}</div>
                            <div class="info">{{ eventApplyText }}</div>
                          </li>
                          <li>
                            <div class="tit">{{ t("home-event-info-location") }}</div>
                            <div class="info">{{ event.eventData.location }}</div>
                          </li>
                          <li>
                            <div class="tit">{{ t("home-event-info-language") }}</div>
                            <div class="info">{{ event.eventData.language }}</div>
                          </li>
                        </ul>
                        <div class="price" v-html="event.eventData.price"></div>
                        <div v-if="event.eventData?.isRegisters" class="btnArea flex">
                          <a :href="event.eventData.link" class="btn blueBtn" target="_blank">{{ registerButtonText }}</a>
                        </div>
                        <div v-if="event.eventData?.isUpcoming" class="btnArea flex">
                          <div class="btn lightBlueBtn">{{ t("common-upcoming") }}</div>
                        </div>
                        <div v-if="event.eventData?.isClosed" class="btnArea flex">
                          <div class="btn closedBtn">{{ t("common-closed") }}<span></span></div>
                        </div>
                      </div>
                    </div>
                    <!-- editor 영역 -->
                    <div v-html="content"></div>
                    <div class="tagArea flex">
                      <div class="shareBtnWrap">
                        <button id="copyLink" class="share flex" @click.stop="methods.onClickShare"><span></span>{{ t("common-share") }}</button>
                      </div>
                    </div>
                    <div class="speakerArea">
                      <div class="title">{{ t("home-event-speakers") }}</div>
                      <ul class="speakerWrap flex">
                        <li v-for="(speaker, index) in event.eventData.speakers" :key="index" class="speakerInfo flex">
                          <div class="profileImgArea">
                            <NuxtImg v-if="speaker.image" :src="speaker.image" format="webp" alt="profile image" />
                            <NuxtImg v-else src="~/assets/images/codepresso_profile_img.svg" alt="profile image" />
                          </div>
                          <div class="textArea">
                            <div class="flex">
                              <div class="tit">{{ speaker.name }}</div>
                              <a v-if="speaker.link" :href="speaker.link" target="_blank"></a>
                            </div>
                            <ul class="info flex">
                              <li>{{ speaker.jobTitle }}</li>
                              <li>{{ speaker.company }}</li>
                            </ul>
                          </div>
                          <ul v-if="speaker.workExperience.length > 0" class="box flex">
                            <li v-for="(experience, index) in speaker.workExperience" :key="index">
                              {{ experience }}
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="rightArea">
                  <!-- sideInfo 1024px 부터 비노출 -->
                  <div class="sideInfo flex">
                    <div class="title">{{ t("home-event-info") }}</div>
                    <ul>
                      <li>
                        <div class="tit">{{ t("home-event-info-date") }}</div>
                        <div class="info">{{ eventDateText }}</div>
                      </li>
                      <li>
                        <div class="tit">{{ t("home-event-info-period") }}</div>
                        <div class="info">{{ eventApplyText }}</div>
                      </li>
                      <li>
                        <div class="tit">{{ t("home-event-info-location") }}</div>
                        <div class="info">{{ event.eventData.location }}</div>
                      </li>
                      <li>
                        <div class="tit">{{ t("home-event-info-language") }}</div>
                        <div class="info">{{ event.eventData.language }}</div>
                      </li>
                    </ul>
                    <div class="price" v-html="event.eventData.price"></div>
                    <div v-if="event.eventData?.isRegisters" class="btnArea flex">
                      <a :href="event.eventData.link" class="btn blueBtn" target="_blank">{{ registerButtonText }}</a>
                    </div>
                    <div v-if="event.eventData?.isUpcoming" class="btnArea flex">
                      <div class="btn lightBlueBtn">{{ t("common-upcoming") }}</div>
                    </div>
                    <div v-if="event.eventData?.isClosed" class="btnArea flex">
                      <div class="btn closedBtn">{{ t("common-closed") }}<span></span></div>
                    </div>
                  </div>
                </div>
              </section>
              <NuxtLink :to="{name: RouteName.HomeEvents}" class="backBtn flex"><span></span><p>{{ t("home-event-all") }}</p></NuxtLink>
            </template>
          </div>
        </div>
      </section>
    </template>
  </LazyHomeCommonLayout>
</template>

<script setup lang="ts">
import {useToastStore} from "~/store/toast/toastStore";
import {ToastType} from "~/components/Common/Toast/model/ToastType";
import {convertTimeToLocalFormatString, ref, useI18n, useSiteNavigationLd} from "#imports";
import {ArticleModel} from "~~/package/mapper/home/model/ArticleModel";
import {useHomeService} from "~/composables/service/useHomeService";
import {BlogDataModel} from "~~/package/mapper/home/model/BlogDataModel";
import {RouteName} from "~~/package/enum/RouteName";
import {useSeoMeta} from "~/composables/useSeoMeta";

const {$i18n} = useNuxtApp();
const { t } = useI18n();
const route = useRoute();
const toastStore = useToastStore();

const homeService = useHomeService();
const content = ref("");
const isInit = ref(false);

const eventId = computed(() => {
  return Number(route.params.eventId)
});

// Fetched at SSG build time so per-article OG tags land in the static HTML
// that SNS bots read. Default keeps the template safe before hydration.
const { data: event, error } = await useAsyncData(
  `event-${eventId.value}`,
  () => homeService.getArticle({id: eventId.value, link: undefined}),
  { default: () => new ArticleModel() },
);

if (error.value || isEmptyString(event.value.title)) {
  await navigateTo('/404', { replace: true });
}

// 글마다 한 언어로만 작성되므로, URL의 /en, /ko 같은 접두어가 실제 글 언어와 다르면
// 검색엔진/사용자에게 잘못된 언어 신호를 주게 된다. 접두어 없는 표준 경로로 301
// 리다이렉트해 그 글의 유일한 유효 접두어(자기 언어) + 접두어 없는 경로만 남긴다.
const routeLangPrefix = route.path.match(/^\/(en|ja|ko|es|vi)(?:\/|$)/);
if (routeLangPrefix && !isEmptyString(event.value.lang) && routeLangPrefix[1] !== event.value.lang.toLowerCase()) {
  await navigateTo(route.path.replace(/^\/(en|ja|ko|es|vi)/, '') || '/', { redirectCode: 301 });
}

const eventData = computed(() => {
  return event.value.eventData ?? new BlogDataModel()
})
const eventDateText = computed(() => {
  if(event.value.eventData.eventStartDate) {
    return `${convertTimeToLocalFormatString(event.value.eventData.eventStartDate, $i18n.locale.value)} ~ ${convertTimeToLocalFormatString(event.value.eventData.eventEndDate, $i18n.locale.value)}`;
  } else {
    return `${convertTimeToLocalFormatString(event.value.eventData.eventEndDate, $i18n.locale.value)}`;
  }
});

const eventApplyText = computed(() => {
  if(event.value.eventData.registrationStartDate) {
    return `${convertTimeToLocalFormatString(event.value.eventData.registrationStartDate, $i18n.locale.value)} ~ ${convertTimeToLocalFormatString(event.value.eventData.registrationEndDate, $i18n.locale.value)}`;
  } else {
    return `${convertTimeToLocalFormatString(event.value.eventData.registrationEndDate, $i18n.locale.value)}`;
  }
})

const registerButtonText = computed(() => {
  if(event.value.eventData.applyButtonText) return event.value.eventData.applyButtonText;
  else return t("home-event-register")
});
const isEmptyMetaData = computed(() => {
  return isEmptyString(event.value.title) || isEmptyString(event.value.info) || isEmptyString(event.value.imageUrl);
})

const siteLinkScript = useSiteNavigationLd();
const { getCanonical, getHreflangLinks } = useSeoMeta();

useHead(() => {
  const title = event.value.title;
  const description = event.value.info;
  const imageUrl = event.value.imageUrl;
  return {
    title,
    meta: [
      { name: 'description', content: description },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:image', content: imageUrl },
      { property: 'og:url', content: `https://codepresso.io${route.path}` },
      { property: 'og:type', content: 'website' },
    ],
    script: [siteLinkScript],
    link: [...getHreflangLinks.value, { rel: 'canonical', href: getCanonical.value }],
  };
});

definePageMeta({
  alias: [
    '/en/home/events/:eventId()',
    '/ja/home/events/:eventId()',
    '/ko/home/events/:eventId()',
    '/vi/home/events/:eventId()',
  ],
})

onMounted(() => {
  methods.getContent().then(() => {
    isInit.value = true;
  });
})

const methods = {
  async getContent() {
    content.value = "";
    try {
      const response = await fetch(eventData.value.contentUrl);
      content.value = await response.text();
    } catch (error) {
      console.error('Error loading HTML:', error);
    }
  },
  onClickShare() {
    const dummy = document.createElement('input');
    const text = window.location.href;

    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);

    toastStore.openToast({
      toastType: ToastType.SUCCESS,
      contents: t("common-link-copy"),
    });
  }
}
</script>

<style lang="scss">
@import "~/assets/scss/abstracts/variables.scss";
@import "~/assets/scss/event_style.scss";

.eventDetail .detailWrap .editorArea {
  width: calc(100%) !important;
}
.detailPage .detailWrap .sideInfo {
  min-width: 320px;
  @media (max-width: 420px) {
    min-width: auto;
  }
}

</style>